import { createContext, useContext } from 'react';

export const GlobalStateContext = createContext();

export function useGlobalState() {
    return useContext(GlobalStateContext);
}